(function () {
    //get the formApp module
    var formApp = angular.module('formApp');

    //set the controller to the code here - the controller uses DataServices.
    formApp.controller('complaintRegisteredFormController',
        ['$scope', '$http', '$controller', 'DataServices', 'UtilityServices', 'ValidationService', '$log', '$location', '$routeParams', '$filter', '$anchorScroll', '$timeout', '$rootScope', 'Constants',
            function ($scope, $http, $controller, DataServices, UtilityServices, ValidationService, $log, $location, $routeParams, $filter, $anchorScroll, $timeout, $rootScope, Constants) {

                // Inherit parent controller
                $controller('questionController', { $scope: $scope });
                $controller('documentController', { $scope: $scope });
                $controller('navigationController', { $scope: $scope });

                var filteredProgramList = [];
                var filteredProgramList1 = [];
                var filteredProgramList2 = [];
                var filteredProgramList3 = [];
                var filteredProgramList4 = [];
                var filteredOrgName1 = [];
                var filteredOrgName2 = [];
                var filteredOrgName3 = [];


                function process(date) {
                    var parts = date.split("/");
                    return new Date(parts[2], parts[1] - 1, parts[0]);
                }
                if ($location.path().indexOf('complaintRegistered/1/complaintdetails') > -1) {
                    if (sessionStorage.getItem('popRegisteredState') != 'shown') {
                        getOptions('dhhsprogram').then(function (result) { // Since it's an SPA application ecentually these sets should be done on services once for whole application
                            DataServices.programRegisteredOriginalResponse = result;
                            filteredProgramList1 = DataServices.programRegisteredOriginalResponse;
                            getOptions('organisation').then(function (result) {
                                DataServices.orgNameOriginalResponse = result.slice();
                                filteredOrgName1 = DataServices.orgNameOriginalResponse;
                                sessionStorage.setItem('popRegisteredState', 'shown')
                                populateFormFields();
                            });
                        });
                    }
                    else {
                        if (DataServices.programRegisteredOriginalResponse.length === 0) {
                            getOptions('dhhsprogram').then(function (result) {
                                filteredProgramList1 = result;
                                getOptions('organisation').then(function (result) {
                                    filteredOrgName1 = result.slice();
                                    populateFormFields();
                                });
                            });
                        }
                        else {
                            filteredProgramList1 = DataServices.programRegisteredOriginalResponse;
                            filteredOrgName1 = DataServices.orgNameOriginalResponse;
                        }

                    }
                }

                if ($location.path().indexOf('complaintRegistered/1/complainantdetails') > -1) {
                    if (sessionStorage.getItem('popNavState') != 'shown') {

                        filteredProgramList4 = $scope.configData.navigationTabs[0].pages.slice();

                        DataServices.navigationTabsOriginalResponse = filteredProgramList4;
                        DataServices.navigationTabsResponse = $scope.configData;

                        sessionStorage.setItem('popNavState', 'shown')
                    }
                    if (window.location.href.indexOf('DH') > -1) {
                        if (DataServices.responseInfo.lodgementDate == null) {
                            if (($scope.configData.navigationTabs[0].title == 'Feedback')) {
                                filteredProgramList2 = $scope.configData.navigationTabs[0].pages.slice();

                                for (var j = 0; j < filteredProgramList2.length; j++) {
                                    if (!(filteredProgramList2[j].title == 'Child Details')) {
                                        filteredProgramList3.push(filteredProgramList2[j]);
                                    }
                                }

                            }
                        }
                        else {
                            if ((DataServices.responseInfo.lodgementDate != null) && DataServices.isDHHSComplaint) {
                                filteredProgramList3 = $scope.configData.navigationTabs[0].pages;
                            }
                            else {
                                if (($scope.configData.navigationTabs[0].title == 'Feedback')) {
                                    filteredProgramList2 = $scope.configData.navigationTabs[0].pages.slice();

                                    for (var j = 0; j < filteredProgramList2.length; j++) {
                                        if (!(filteredProgramList2[j].title == 'Child Details')) {
                                            filteredProgramList3.push(filteredProgramList2[j]);
                                        }
                                    }

                                }
                            }
                        }
                        $scope.configData.navigationTabs[0].pages = filteredProgramList3;
                    }
                    else {
                        $scope.configData.navigationTabs[0].pages = $scope.configData.navigationTabs[0].pages;
                    }

                }

                var config = DataServices.getCachedConfigData(Constants.ConfigTemplate.complaintRegistered);
                if (config) {
                    $scope.setupTriggersAndDynamicValues();
                    $scope.setSummaryErrorFocus();
                    document.title = $scope.utility.getPageTitle($scope.navTabNum, $scope.pageUrl);
                }
                else {
                    DataServices.getConfiguration(Constants.ConfigTemplate.complaintRegistered, $scope.versionNumber)
                        .then(function (data) {
                            DataServices.pushConfigData(data.configData, Constants.ConfigTemplate.complaintRegistered, data.versionNumber, data.role);

                            $scope.setupTriggersAndDynamicValues();
                            $scope.setSummaryErrorFocus();
                            document.title = $scope.utility.getPageTitle($scope.navTabNum, $scope.pageUrl);
                        });
                }

                // default access for attaching documents (NOTE: this needs to come from the user role)
                DataServices.responseInfo.access = {
                    canSaveFile: UtilityServices.isCurrentIncidentEditable(),
                    canViewFile: true,
                    canDeleteFile: UtilityServices.isCurrentIncidentEditable()
                };

                $scope.isDH = function () {
                    if ($location.path().indexOf('DH') > -1) {
                        $scope.IsDHVisible = true;
                        return true;
                    }
                    else {
                        $scope.IsDHVisible = false;
                        return false;
                    }
                }

                function populateFormFields() {
                    if ($location.path().indexOf('DH') > -1) {
                        if (DataServices.responseInfo.lodgementDate == null || DataServices.isDHComplaint) {
                            for (var j = 0; j < filteredProgramList1.length; j++) {
                                if (filteredProgramList1[j].text == 'Covid19' || filteredProgramList1[j].text == 'Health'  || filteredProgramList1[j].text == 'Family Violence and Sexual Assault Services') {
                                    filteredProgramList.push(filteredProgramList1[j]);
                                }
                            }
                            for (var k = 0; k < filteredOrgName1.length; k++) {
                                if (!(filteredOrgName1[k].text == 'Department of Families, Fairness and Housing')) {
                                    //filteredProgramList2.navigationTabs[i].pages.splice(j, 1);
                                    filteredOrgName3.push(filteredOrgName1[k]);
                                }
                            }
                        }
                        else {
                            for (var a = 0; a < filteredProgramList1.length; a++) {
                                if (!(filteredProgramList1[a].text == 'Covid19' || filteredProgramList1[a].text == 'Community Health' || filteredProgramList1[a].text == 'Fairness')) {
                                    filteredProgramList.push(filteredProgramList1[a]);
                                }
                            }
                            filteredOrgName3 = filteredOrgName1;
                        }
                    }
                    else {
                        if (DataServices.responseInfo.lodgementDate == null || DataServices.isDFFHComplaint) {
                            for (var l = 0; l < filteredProgramList1.length; l++) {
                                if (!(filteredProgramList1[l].text == 'Covid19' || filteredProgramList1[l].text == 'Health')) {
                                    filteredProgramList.push(filteredProgramList1[l]);
                                }
                            }
                            for (var m = 0; m < filteredOrgName1.length; m++) {
                                if (!(filteredOrgName1[m].text == 'Department of Health')) {
                                    //filteredProgramList2.navigationTabs[i].pages.splice(j, 1);
                                    filteredOrgName3.push(filteredOrgName1[m]);
                                }
                            }
                        }
                        else {
                            for (var b = 0; b < filteredProgramList1.length; b++) {
                                if (!(filteredProgramList1[b].text == 'Covid19' || filteredProgramList1[b].text == 'Community Health' || filteredProgramList1[b].text == 'Fairness')) {
                                    filteredProgramList.push(filteredProgramList1[b]);
                                }
                            }
                            filteredOrgName3 = filteredOrgName1;
                        }
                    }
                    DataServices.configData.optionSets["dhhsprogram"] = filteredProgramList;
                    $scope.configData.optionSets["organisation"] = filteredOrgName3;
                }

                function cutoffDate() {
                    if (DataServices.responseInfo.lodgementDate == null || DataServices.isDHComplaint || DataServices.isDFFHComplaint) {
                        $scope.isAfterCutOffDate = true;
                    }
                    else {
                        $scope.isAfterCutOffDate = false;
                    }

                }


                // TODO: We need to go through this to de-clutter!!
                // Complaint specific scope items
                $scope.access = DataServices.responseInfo.access;
                $scope.incidentId = DataServices.responseInfo.incidentId;
                $scope.incidentRef = DataServices.responseInfo.incidentRef;
                $scope.status = DataServices.responseInfo.status;
                $scope.statusText = DataServices.responseInfo.statusText;
                $scope.reportedDate = DataServices.responseInfo.reportedDate ? moment(DataServices.responseInfo.reportedDate).format($scope.Constants.ausDateFormat) : null;
                $scope.submittedDate = DataServices.responseInfo.submittedDate ? moment(DataServices.responseInfo.submittedDate).format($scope.Constants.ausDateFormat) : null;
                $scope.template = Constants.ConfigTemplate.complaintRegistered;
                $scope.role = DataServices.responseInfo.role;
                $scope.feedbackType = Constants.FeedbackType.Complaint;

                // Saves the current feedback
                $scope.saveFeedback = function (btnId) {

                    $scope.currentLoadSaveMessage = "Saving complaint";
                    var noMandatoryChecksForSave = true;
                    if ($scope.isPageEditable === true && $scope.validatePage($scope.navTabNum, $scope.pageUrl, null, null, null, 'inline', null, noMandatoryChecksForSave)) {
                        // save Feedback for authenticated user
                        if (!angular.equals($scope.originalResponse, $scope.responses)) {
                            // Perform user access check first to determine if user is warned, then save Feedback.
                            saveFeedbackRegisteredUser($scope.feedbackType, btnId);
                        }
                        else {
                            // No changes have been made, alert user
                            $scope.utility.openPopup('noChangesSaveNotRequired', { incidentRef: $scope.incidentRef });
                        }
                    }
                    else {
                        $scope.alertFirstError();
                    }

                    // save failed if we reach here.
                    return null;
                }

                //person details
                $scope.getLocalCouncilFromAddressForClient = function (pIndex, sIndex) {
                    var clientdetails = $scope.responses["1-2"][0].clientdetails;
                    var details = clientdetails[sIndex];
                    if (details["cDAddress-lga"] === undefined) {
                        details["cDAddress-lga"] = "";
                    }
                    if (details["cDAddress-stateCode"] === undefined) {
                        details["cDAddress-stateCode"] = "Local Council";
                    }
                    if (details !== undefined && details["cDAddress-stateCode"] !== undefined && details["cDAddress-lga"] !== undefined) {
                        var localCouncilDetails = DataServices.getLocalCouncilFromAddress(details["cDAddress-stateCode"], details["cDAddress-lga"]);
                        details["cDLocalCouncil"] = localCouncilDetails.code;
                        details["cDLocalCouncilText"] = localCouncilDetails.text;
                        return localCouncilDetails.text;
                    }
                }

                $scope.IsOtherOrgSelected = function () {
                    if ($scope.responses["1-4"][0]["serviceDetails"][0] !== null && $scope.responses["1-4"][0]["serviceDetails"][0] !== undefined && $scope.responses["1-4"][0]["serviceDetails"][0]["sPOrgName"] !== null
                        && $scope.responses["1-4"][0]["serviceDetails"][0]["sPOrgName"] !== undefined) {
                        return $scope.responses["1-4"][0]["serviceDetails"][0]["sPOrgName"]["text"] === "Other";
                    }
                    else {
                        return false;
                    }
                }

                //your details/Complainant details
                $scope.getLocalCouncilFromAddress = function () {
                    var responses = $scope.responses["1-1"][0];
                    var complainantdetails = responses["complainantdetails"][0];

                    if (complainantdetails["rDAddress-lga"] === undefined) {
                        complainantdetails["rDAddress-lga"] = "";
                    }
                    if (complainantdetails["rDAddress-stateCode"] === undefined) {
                        complainantdetails["rDAddress-stateCode"] = "Local Council";
                    }
                    if (complainantdetails !== undefined && complainantdetails["rDAddress-stateCode"] !== undefined && complainantdetails["rDAddress-lga"] !== undefined) {
                        var localCouncilDetails = DataServices.getLocalCouncilFromAddress(complainantdetails["rDAddress-stateCode"], complainantdetails["rDAddress-lga"]);
                        complainantdetails["rDLocalCouncil"] = localCouncilDetails.code;
                        complainantdetails["rDLocalCouncilText"] = localCouncilDetails.text;
                        return localCouncilDetails.text;
                    }
                }

                $scope.onAnonymousCheckChange = function () {
                    var complainantDetails = $scope.responses["1-1"][0].complainantdetails[0];
                    if (complainantDetails.rDAnonymous === "yes") {
                        DataServices.setAnonymousDetails(complainantDetails, true);
                        $scope.utility.removeFromValidationErrors(null, $scope.pageId, null, null, null, null);
                    }
                    else {
                        DataServices.setAnonymousDetails(complainantDetails, false);
                    }
                }

                $scope.isAnonymousSelected = function () {
                    var complainantDetails = $scope.responses["1-1"][0].complainantdetails[0];
                    if (complainantDetails.rDAnonymous === "yes") {
                        return true;
                    }
                    else {
                        return false;
                    }
                }

                $scope.IsOtherProgramSelected = function () {
                    return UtilityServices.getOptionSetText('dhtypeofservice',$scope.responses["1-4"][0]["serviceDetails"][0]["sPProgram_DH"]) === "Other";
                }  

                $scope.IsOtherOrgSelected = function () {
                    if ($scope.responses["1-4"][0]["serviceDetails"][0] !== null
                        && $scope.responses["1-4"][0]["serviceDetails"][0] !== undefined
                        && $scope.responses["1-4"][0]["serviceDetails"][0]["sPOrgName"] !== null
                        && $scope.responses["1-4"][0]["serviceDetails"][0]["sPOrgName"] !== undefined) {
                        return $scope.responses["1-4"][0]["serviceDetails"][0]["sPOrgName"]["text"] === "Other";
                    }
                    else {
                        return false;
                    }
                }

                $scope.IsOtherOrgSelectedForDh = function () {
                    if ($scope.responses["1-4"][0]["serviceDetails"][0] !== null
                        && $scope.responses["1-4"][0]["serviceDetails"][0] !== undefined
                        && $scope.responses["1-4"][0]["serviceDetails"][0]["sPOrgName_DH"] !== null
                        && $scope.responses["1-4"][0]["serviceDetails"][0]["sPOrgName_DH"] !== undefined) {
                        return $scope.responses["1-4"][0]["serviceDetails"][0]["sPOrgName_DH"]["text"] === "Other";
                    }
                    else {
                        return false;
                    }
                }

                doesDivisionHaveValue = function () {
                    var serviceDetails = $scope.responses["1-4"][0].serviceDetails[0];

                    if (serviceDetails.sPDHSecondaryProgram === undefined || serviceDetails.sPDHSecondaryProgram === null) {
                        return false;
                    }
                    else {
                        return true;
                    }
                }

                doesBranchHaveValue = function () {
                    var serviceDetails = $scope.responses["1-4"][0].serviceDetails[0];
                    
                    if (serviceDetails.sPServiceType_DH === undefined || serviceDetails.sPServiceType_DH === null) {
                        return false;
                    }
                    else {
                        return true;
                    }
                }

                $scope.haveAnyUnits = function () {
                    
                    if (!doesBranchHaveValue() || document.getElementById("0-serviceDetails-0-sPServiceArea_DH") === null) {
                        return false;
                    }

                    var unitList = document.getElementById("0-serviceDetails-0-sPServiceArea_DH").options;
                    
                    if (unitList != null && unitList.length > 1) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }

                $scope.haveAnyBranches = function () {
                    
                    if (!doesDivisionHaveValue() || document.getElementById("0-serviceDetails-0-sPServiceType_DH") === null) {
                        return false;
                    }

                    var unitList = document.getElementById("0-serviceDetails-0-sPServiceType_DH").options;

                    if (unitList != null && unitList.length > 2) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }

                function getOptions(optionset) {
                    return ($scope.utility.getOptionSetFromConfiguration(optionset, Constants.ConfigTemplate.complaintRegistered));
                }

                function getLocalCouncilDetails(localCouncil) {
                    var matchedLga = $scope.configData.optionSets
                        .localgovernmentarea
                        .filter(function (item) { return item.text === localCouncil; });
                    if (matchedLga.length > 0) {
                        return matchedLga[0];
                    }
                }

                function validateComplaintsForm() {
                    var isValid = true;
                    var previousPageId = $scope.pageId;

                    $scope.configData.navigationTabs.forEach(function (tab) {
                        tab.pages.forEach(function (page) {
                            var pageId = tab.number + '-' + page.number;
                            $scope.pageId = pageId;
                            if (page.template !== "summary" && $scope.responses[pageId] === undefined || $scope.responses[pageId] === null) {
                                if ($scope.$eval(page.condition, null) == true) {
                                    isValid = false
                                }
                            }
                            else {
                                var isPageValid = $scope.validatePage(tab.number, page.url, null, null, null, 'inline', true);
                                if (isPageValid === false) {
                                    isValid = false;
                                }
                            }
                        });
                    });

                    $scope.pageId = previousPageId;
                    return isValid;
                }

                // Submits the feedback if there are no validation errors.
                $scope.submitFeedback = function () {
                    //Clearing the validation errors
                    $scope.validationErrors.length = 0;
                    if (validateComplaintsForm()) {
                        $scope.currentLoadSubmitMessage = "Submitting Complaint";

                        // TODO: we need a cleaner way of injecting this captcha value.
                        DataServices.responseInfo.captchaResponse = $scope.valueOfQuestion(null, 'cOCaptcha', 'consent', 0, 0);

                        $scope.isSaving = true;
                        cutoffDate();
                        DataServices.submitIncident($scope.feedbackType, $scope.IsDHVisible, $scope.isAfterCutOffDate)
                            .then(function (response) {
                                if (response.data && response.data.status == 2) {
                                    $scope.utility.openPopup('savedElsewhere', { lastUpdatedBy: response.data.lastUpdatedBy });
                                }
                                else {
                                    if (response.data && response.data.id) {
                                        DataServices.trackEventsWithGA('Submit action in ' + $scope.pageUrl, 'Click Submit To Manager', 'Successfully Submitted Incident');

                                        $scope.updateStatusBarInformation(response.data);

                                        $scope.goToNextPage();
                                    }
                                    else {
                                        $scope.utility.showNotification(true, 'internalError');
                                    }
                                }
                            }, function (response) {
                                $scope.utility.openPopup('errorSubmit');
                                DataServices.trackEventsWithGA('Error occured during Submiting in ' + $scope.pageUrl, 'Click Submit To Manager', 'Failed to Submit Incident');
                            })
                            .finally(function () {
                                $scope.isSaving = false;
                            });
                    }
                    else {
                        if ($scope.validationErrors !== null && $scope.validationErrors !== undefined) {
                            if ($scope.validationErrors.length > 0) {
                                var error = $scope.validationErrors[0];
                                var tabNum = error.pageNo.split("-")[0];
                                var pageNum = error.pageNo.split("-")[1];
                                var page = $scope.configData.navigationTabs[tabNum - 1].pages[pageNum - 1];
                                ExpandErroredSections("1-2", "clientdetails");
                                ExpandErroredSections("1-3", "childdetails");


                                $scope.utility
                                    .openPopup('reviewComplaintErrors').result
                                    .then(function (data) {
                                        $scope.goToPage(tabNum, page.url);
                                    });
                            }
                            else {
                                $scope.utility
                                    .openPopup('reviewComplaintErrors');
                            }
                        }
                    }
                };

                function ExpandErroredSections(pageId, sectionName) {
                    //Expanding the error sections
                    var errorSectionIndexList = [];
                    $scope.validationErrors.forEach(function (error) {
                        if (error.pageNo === pageId && error.pageIndex === 0 && error.sectionCode === sectionName) {
                            if (errorSectionIndexList.indexOf(error.sectionIndex) === -1) {
                                errorSectionIndexList.push(error.sectionIndex);
                            }
                        }
                    });

                    if (errorSectionIndexList.length > 0) {
                        errorSectionIndexList.forEach(function (sectionIndex) {
                            $scope.responses[pageId][0][sectionName][sectionIndex].$state = "Editing";
                        });
                    }
                }

                // Downloads the PDF
                $scope.downloadPdf = function (qCode) {

                    DataServices.trackEventsWithGA('Download PDF action in ' + $scope.pageUrl, 'Click Download PDF', 'Download Feedback PDF');
                    $scope.isButtonLoading[qCode] = true;

                    DataServices.viewComplaintsRegisteredPdf($scope.incidentId)
                        .then(function (response) {
                            var data = response && response.data;
                            try {
                                var file = new Blob([data], { type: "application/pdf" }, { name: DataServices.responseInfo.incidentRef });
                                //if (window.Blob && window.navigator.msSaveOrOpenBlob) {
                                //    saveAs(file, DataServices.responseInfo.incidentRef + '.pdf');
                                //}
                                saveAs(file, DataServices.responseInfo.incidentRef + '.pdf');
                            }
                            catch (e) {
                                $scope.utility.openPopup('errorDownloadPdf');
                            }
                            $scope.isButtonLoading[qCode] = false;
                        }, function () {
                            $scope.utility.openPopup('errorDownloadPdf');
                            $scope.isButtonLoading[qCode] = false;
                        });
                };


                // Updates information needed for the status bar
                $scope.updateStatusBarInformation = function (response) {

                    DataServices.responseInfo.incidentId = response.id;
                    DataServices.responseInfo.incidentRef = response.ref;
                    DataServices.responseInfo.lastUpdatedTime = response.allocatedLastUpdatedTime;
                    DataServices.responseInfo.reportedDate = response.reportedDate;
                    DataServices.responseInfo.submittedDate = response.submittedDate;
                    DataServices.responseInfo.status = response.incidentStatus || response.feedbackStatusId;
                    DataServices.responseInfo.statusText = response.incidentStatusText;

                    // Set original response to current response as update has occurred.
                    $scope.originalResponse = angular.copy($scope.responses);

                    $scope.incidentId = DataServices.responseInfo.incidentId;
                    $scope.incidentRef = DataServices.responseInfo.incidentRef;
                    $scope.lastUpdatedTime = DataServices.responseInfo.lastUpdatedTime;
                    $scope.reportedDate = DataServices.responseInfo.reportedDate ? moment(DataServices.responseInfo.reportedDate).format($scope.Constants.ausDateFormat) : null;
                    $scope.submittedDate = DataServices.responseInfo.submittedDate ? moment(DataServices.responseInfo.submittedDate).format($scope.Constants.ausDateFormat) : null;
                    $scope.status = DataServices.responseInfo.status;
                    $scope.statusText = DataServices.responseInfo.statusText;
                    $scope.role = DataServices.responseInfo.role;

                    if (response.formConfig && response.formConfig.configData) {
                        // Explicitly set config data
                        DataServices.configData = response.formConfig.configData;
                        $scope.configData = response.formConfig.configData;

                        DataServices.pushConfigData(response.formConfig.configData, Constants.ConfigTemplate.complaint, response.formConfig.versionNumber, response.formConfig.role);
                    }
                }

                // ******************************************
                // NOTE: All local functions below this line.
                // ******************************************

                // Performs the actual save for registered users
                var saveFeedbackRegisteredUser = function (feedbackType, btnId) {

                    if ($scope.validatePage($scope.navTabNum, $scope.pageUrl, null, null, null, 'inline', null, true)) {

                        $scope.isSaving = true;
                        cutoffDate();
                        DataServices.saveIncidentRegisteredUser(feedbackType, $scope.IsDHVisible, $scope.isAfterCutOffDate)
                            .then(
                                function (response) {
                                    $scope.isSaving = false;

                                    if (response.data && response.data.status == 2) {
                                        $scope.utility.openPopup('savedElsewhere',
                                            { lastUpdatedBy: response.data.lastUpdatedBy });
                                    }
                                    else {
                                        if (response.data && response.data.id) {
                                            DataServices.trackEventsWithGA('Save action in ' + $scope.pageUrl, 'Click Save Incident Registered User', 'Successfully Saved Incident');

                                            $scope.updateStatusBarInformation(response.data);
                                            $scope.utility.openPopup('successSaveComplaint',
                                                {
                                                    incidentRef: response.data.ref,
                                                    oldStatusText: $scope.statusText,
                                                    statusText: "Save Sucessfully"
                                                    //response.data.incidentStatusText
                                                }).closed.then(function () {
                                                    $rootScope.allowFormNavigation = false;
                                                    $scope.returnToComplaints();
                                                });
                                        } else {
                                            $scope.utility.showNotification(true, 'internalError');
                                        }
                                    }
                                },
                                function (response) {
                                    $scope.isSaving = false;
                                    $scope.utility.openPopup('errorSave');
                                    DataServices.trackEventsWithGA('Error occured during Save in ' + $scope.pageUrl,
                                        'Click Save Incident Registered User',
                                        'Failed to Save Incident');
                                }
                            );
                    }
                }


                $scope.callCancelFollowUp = function () {
                    $scope.cancel();
                };


                $scope.cancel = function () {
                    // function to call on window close on Incident form
                    if (DataServices.isFullyRegisteredUser()) {
                        if ($scope.isPageEditable && $scope.confirmUserCancel()) {
                            // for registered users
                            // display a confirmation message
                            $scope.utility.openPopup('warnUserBeforeCancelRegisteredUser').result
                                .then(function (data) {
                                    if (data.result == "thirdButtonClick") {
                                        // On Yes, Save the changes
                                        $rootScope.allowFormNavigation = false;
                                        saveFeedbackRegisteredUser($scope.feedbackType);
                                    }
                                    else {
                                        // TODO: Fix the question controller to be able to bypass the validation check when we
                                        //       actually just want to leave, in the mean time this will get us to the right place
                                        $location.path(Constants.Url.landing);
                                    }
                                });

                        } else {
                            $scope.returnToComplaints();
                        }
                    }
                    else {
                        // for direct users 
                        // If user chose Yes, current page is closed and landing page is displayed.
                        // If user selects 'No', system stays on the current page.
                        $scope.utility.openPopup('warnUserBeforeCancel').result.then(
                            function (result) {
                                // On Yes go to landing page
                                $rootScope.allowFormNavigation = false;
                                $scope.returnToComplaints();
                            });
                    }
                }



                $scope.returnToComplaints = function () {
                    $location.path(Constants.Url.manageComplaints);
                }
            }]);
}());